import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout route para /dashboard/$dashboardId/incorporadoras
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
// Usando Directory Routes: dashboard.$dashboardId.incorporadoras/route.tsx
// route.tsx = layout route (sempre renderizado)
// Renderiza o <Outlet /> para as rotas filhas (index.tsx, $incorporadoraId/index.tsx, etc)
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/incorporadoras',
)({
  component: function IncorporadorasLayout() {
    return <Outlet />
  },
})
